import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { generalUtils } from "utilities";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import DismissableModal from "DismissableModal";
import PostCardOptionsButton from "./PostCardOptionsButton";
import "./styles.scss";
import PostVisibilityOptionsModal, {
  PostVisibilityOptionsButton,
} from "PostVisibilityOptionsModal";
const PostCard = ({
  post,
  company,
  userIsAdmin,
  showPostPortfolioRecipientsIndicator,
}) => {
  const [note, setNote] = useState("");

  const [showRequestAccessModal, setShowRequestAccessModal] = useState(false);
  const [postState, setPostState] = useState(post);

  const [showPostVisibilityOptionsModal, setShowPostVisibilityOptionsModal] =
    useState(false);

  const handlePostVisibilityOptionsModalClose = () => {
    setShowPostVisibilityOptionsModal(false);
  };

  const publishedTimestamp = generalUtils.formatTimestampToTextMonth(
    postState.timestamp_published
  );

  const visibilityIconSrcMap = [
    {
      visibility: "private",
      src: "/images/icons/lock-outline-icon-black.svg",
      label: "Private",
    },
    {
      visibility: "recipients_only",
      src: "/images/icons/lock-outline-icon-black.svg",
      label: "Private",
    },
    {
      visibility: "contact_groups",
      src: "/images/icons/users.svg",
      label: "Network",
    },
    {
      visibility: "public",
      src: "/images/icons/globe-black-icon.svg",
      label: "Public",
    },
  ];

  const visibilityIconSrcItem = visibilityIconSrcMap.filter(
    (visibilityIconValueSrc) =>
      postState.visibility === visibilityIconValueSrc.visibility
  );

  const visibilityIconSrc = visibilityIconSrcItem.length
    ? visibilityIconSrcItem[0].src
    : "";

  const visibilityIconLabel = visibilityIconSrcItem.length
    ? visibilityIconSrcItem[0].label
    : "";

  const visibilityIndicatorIcon = () => {
    if (showPostPortfolioRecipientsIndicator) {
      let postIsVisible = true;

      if (
        postState.visibility !== "public" &&
        postState.portfolio_recipients.length < 1
      ) {
        postIsVisible = false;
      }

      return (
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={
            <Tooltip id="eye-icon">
              <div style={{ textAlign: "left" }}>
                {postState.visibility === "public" && (
                  <React.Fragment>Visible by anyone</React.Fragment>
                )}
                {postState.visibility !== "public" && postIsVisible && (
                  <div>
                    Sent to:
                    {postState.portfolio_recipients.map((recipient, index) => (
                      <div key={index}>{recipient}</div>
                    ))}
                  </div>
                )}
                {postState.visibility !== "public" && !postIsVisible && (
                  <div>
                    This update has not been shared with any admins of this
                    portfolio.
                  </div>
                )}
              </div>
            </Tooltip>
          }
        >
          <img
            className="ps-post-card__eye-icon"
            src={
              postIsVisible === true
                ? "/images/icons/eye-black-icon.svg"
                : "/images/icons/eye-off-black-icon.svg"
            }
          />
        </OverlayTrigger>
      );
    } else {
      let postIsVisible = false;

      if (postState.body_html) {
        postIsVisible = true;
      }

      if (!postIsVisible) {
        return (
          <OverlayTrigger
            placement="left"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip id="eye-icon">
                <div>
                  This update has not been shared with you. Connect with this
                  company to request access and receive future updates.
                </div>
              </Tooltip>
            }
          >
            <img
              className="ps-post-card__eye-icon"
              src={"/images/icons/eye-off-black-icon.svg"}
            />
          </OverlayTrigger>
        );
      } else {
        return <div></div>;
      }
    }
  };

  const [contactGroups, setContactGroups] = useState([]);
  const [selectedContactGroups, setSelectedContactGroups] = useState([]);
  const [initialGroups, setInitialGroups] = useState([]);

  useEffect(() => {
    const getInitialData = async () => {
      let lists_result = [];
      try {
        lists_result = await axios.get(
          "/api/v2/companies/" + post.company_id + "/email_lists"
        );
      } catch (err) {
        console.log(err.stack);
      }

      setContactGroups(
        lists_result.data.map((group) => {
          return {
            ...group,
            label: group.display_name,
            value: group.email_list_id,
          };
        })
      );
      if (post.visibility === "contact_groups") {
        let visible_groups = [];
        try {
          visible_groups = await axios.get(
            "/api/v2/companies/" +
              post.company_id +
              "/posts/" +
              post.post_id +
              "/visible_email_lists"
          );
        } catch (err) {
          console.log(err.stack);
        }

        setInitialGroups(
          visible_groups.data.map((group) => {
            return {
              ...group,
              label: group.display_name,
              value: group.email_list_id,
            };
          })
        );
        setSelectedContactGroups(
          visible_groups.data.map((group) => {
            return {
              ...group,
              label: group.display_name,
              value: group.email_list_id,
            };
          })
        );
      }
    };

    if (post.post_id && post.company_id && userIsAdmin) {
      getInitialData();
    }
  }, [post.post_id, post.company_id]);
  let bodyRef = useRef(null);
  let [open, setOpen] = useState(false);
  let [showReadMore, setShowReadMore] = useState(false);
  const [ref, setRef] = useState();

  useEffect(() => {
    if (bodyRef && bodyRef.current) {
      setShowReadMore(bodyRef.current.clientHeight > 300);
    }
  }, [ref]);

  const getHostedUpdateUrl = () => {
    return generalUtils.generateHostedUpdateSlug(
      window.location.origin,
      company.name,
      post.title,
      post.post_id
    );
  };

  return (
    <div>
      <div
        className="ps-card--primary ps-post-card"
        style={{
          maxHeight: open ? "unset" : "500px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div className="ps-post-card__header-container">
          <div className="ps-post-card__author-title-container">
            <div className="ps-post-card__title-text-container">
              <div className="ps-post-card__title-text">{postState.title}</div>
            </div>
            <div className="ps-post-card__sub-title-container">
              {/* <div className="ps-post-card__author-text">
                {post.author.first_name} {post.author.last_name}
              </div>
              <div style={{ marginRight: "10px" }}>·</div> */}
              <div className="ps-post-card__date-text">
                {publishedTimestamp}
              </div>
              <div style={{ marginRight: "10px" }}>·</div>

              {!userIsAdmin && (
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id="visibility-icon">
                      {visibilityIconLabel}
                    </Tooltip>
                  }
                >
                  <img style={{ height: "14px" }} src={visibilityIconSrc} />
                </OverlayTrigger>
              )}
              {userIsAdmin && (
                <PostVisibilityOptionsButton
                  post={postState}
                  updateModalState={setShowPostVisibilityOptionsModal}
                />
              )}
            </div>
          </div>
          <div className="ps-post-card__right-header-container">
            {/* <div className="ps-post-card__date-text">{publishedTimestamp}</div> */}
            <div className="ps-post-card__date-options-container">
              <a href={getHostedUpdateUrl()} target="_blank" rel="noreferrer">
                <img
                  className="ps-post-card__title-external-link-icon"
                  src="/images/icons/black-external-link-icon.svg"
                />
              </a>

              {visibilityIndicatorIcon()}

              {userIsAdmin && (
                <div style={{ marginLeft: "10px" }}>
                  <PostCardOptionsButton
                    postId={post.post_id}
                    company={company}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className="ps-card--update-body"
          style={{ marginBottom: open ? "60px" : "0" }}
        >
          <div className="d-flex flex-row">
            <div>
              {/* <img
                style=""
                className="ps-card__circle-avatar-image-fifty"
                src={post.postAuthor.profile_image_url}
              /> */}
            </div>
          </div>

          {postState.body_html && (
            <React.Fragment>
              <hr className="ps-divider--secondary my-4" />
              <div>
                <div
                  ref={bodyRef}
                  dangerouslySetInnerHTML={{ __html: postState.body_html }}
                ></div>
              </div>
            </React.Fragment>
          )}

          {/*           
          {!postState.body_html && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "40px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  This Update has not been shared with you or any of the admins
                  of this Portfolio. Either request access or invite additional
                  Portfolio admins who might have recieved this Update in order
                  to view.
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  className="mt-3"
                >
                  <button
                    className="btn ps-btn--primary"
                    onClick={() => {
                      setShowRequestAccessModal(true);
                    }}
                  >
                    Request Access
                  </button>
                </div>
              </div>
              <DismissableModal
                handleClose={setShowRequestAccessModal}
                show={showRequestAccessModal}
                modalHeading="Request Update Access"
                modalSubheading="Request access to this update by sending an Access Request. Optionally include a short note below."
                modalBody={
                  <div className={"mb-1 d-flex flex-column"}>
                    <div>
                      Included Note:
                      <br />
                      John Smith (john@smitchventures.vc) has requested access
                      to your Update titled, &apos;Moon Rising Fall Update&apos;
                      <br />
                      <br />
                      Navigate to this Update to share it with John?
                      <br />
                      <br />
                      Pro tip: If John Smith is already in one of your Contact
                      Groups, we recommend sharing this and future Updates with
                      the entire group by using the Update Privacy Settings.
                      <br />
                      <br />
                      Share This Update
                      <br />
                      <br />
                      It looks like John Smith is already in a Contact Group
                      labeled: Investors
                      <br />
                      <br />
                      In that case, we recommend adjusting the privacy
                      visibility setting to Contact Groups and including this
                      Contact Group in the list of approved contacts.
                    </div>
                    <label htmlFor="">Note</label>
                    <textarea
                      className={
                        note.length === 500
                          ? "input-textarea--primary ps-dismissable-modal__input ps-dismissable-modal__input--full"
                          : "input-textarea--primary ps-dismissable-modal__input"
                      }
                      value={note}
                      onChange={(e) => {
                        setNote(e.target.value);
                      }}
                      maxLength="500"
                      name=""
                      id=""
                      cols="30"
                      rows="10"
                    />
                    <span
                      className={
                        note.length === 500
                          ? "ps-track-request-note-count ps-track-request-note-count--full"
                          : "ps-track-request-note-count"
                      }
                    >
                      {note.length}/500
                    </span>
                  </div>
                }
                modalFooter={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <button
                      className="btn ps-btn--white"
                      onClick={() => {
                        setShowRequestAccessModal(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button className="btn ps-btn--primary" onClick={() => {}}>
                      Send Access Request
                    </button>
                  </div>
                }
              />
            </div>
          )} */}
        </div>
        {showReadMore && (
          <div
            style={{
              position: "absolute",
              bottom: "0px",
              width: "100%",
              padding: "15px 0px 20px 0",
              background: "white",
            }}
          >
            <button
              className={"btn ps-btn--white ps-btn--white-sm"}
              onClick={() => {
                setOpen((x) => !x);
              }}
            >
              {open ? "Read Less" : "Read More"}
            </button>
          </div>
        )}
      </div>
      {userIsAdmin && (
        <PostVisibilityOptionsModal
          className={"ps-post-visibility-options-modal"}
          setShowPostVisibilityOptionsModal={setShowPostVisibilityOptionsModal}
          show={showPostVisibilityOptionsModal}
          companyId={post.company_id}
          companyName={company.name}
          postId={postState.post_id}
          post={postState}
          initialGroups={initialGroups}
          setInitialGroups={setInitialGroups}
          selectedContactGroups={selectedContactGroups}
          setSelectedContactGroups={setSelectedContactGroups}
          contactGroups={contactGroups}
          setContactGroups={setContactGroups}
          handlePostVisibilityOptionsModalClose={
            handlePostVisibilityOptionsModalClose
          }
          handleUpdatePost={async (updatedPost) => {
            setPostState({ ...postState, ...updatedPost });
          }}
        />
      )}
    </div>
  );
};

PostCard.propTypes = {
  post: PropTypes.object,
};

export default PostCard;
